import React from 'react'
import ContactFormCard from '../../../react4xp/components/ContactFormPart'

function ContactFormCardPart({ backgroundColor, title, text, image, dropdownText, links }) {
	return (
		<ContactFormCard
			bgColor={backgroundColor}
			title={title}
			text={text}
			img={image.link && {
				src: image.link,
				alt: image.alt
			}}
			dropdown={dropdownText && {
				default: dropdownText,
				options: links?.map(link => ({
					text: link.text,
					link: link.url
				}))
			}}
		/>
	)
}

export default (props) => <ContactFormCardPart {...props} />
